import * as v from 'valibot';
import { createEnv } from 'valibot-env/nextjs';
import { deployableEnvSchema } from './schema';

export const env = createEnv({
  schema: {
    public: {
      NEXT_PUBLIC_ABSMARTLY_API_KEY: v.fallback(v.string(), ''),
      NEXT_PUBLIC_DEPLOYABLE_ENV: deployableEnvSchema,
      NEXT_PUBLIC_CLIENT_SEGMENT_WRITE_KEY: v.fallback(v.string(), ''),
      NEXT_PUBLIC_DD_CLIENT_TOKEN: v.fallback(v.string(), ''),
      NEXT_PUBLIC_SUPERGRAPH_URL: v.pipe(
        v.string(),
        v.url('NEXT_PUBLIC_SUPERGRAPH_URL must be a valid URL'),
      ),
      NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA: v.fallback(v.string(), ''),
      NEXT_PUBLIC_NW_URL: v.fallback(
        v.pipe(v.string(), v.url('NEXT_PUBLIC_NW_URL must be a valid URL')),
        'https://stage.nerdwallet.biz/',
      ),
      NEXT_PUBLIC_SURVICATE_WORKSPACE_KEY: v.fallback(v.string(), ''),
    },
    private: {
      CRON_SECRET: v.fallback(v.string(), ''),
      CARDFINDER_SESSION_TOKEN_SECRET: v.fallback(v.string(), ''),
      MARKETPLACE_WEBHOOK_TOKEN: v.fallback(v.string(), ''),
      SUPERGRAPH_INTERNAL_URL: v.pipe(
        v.string(),
        v.url('SUPERGRAPH_INTERNAL_URL must be a valid URL'),
      ),
      NEXT_RUNTIME: v.pipe(
        v.picklist(['nodejs', 'edge']),
        v.transform(val => val.toLowerCase()),
      ),
      LOG_LEVEL: v.pipe(
        v.fallback(
          v.picklist(['silent', 'trace', 'debug', 'info', 'warn', 'error', 'fatal', 'critical']),
          'info',
        ),
        v.transform(val => val.toLowerCase()),
      ),
      AWS_ELASTICACHE_HOSTNAME: v.pipe(
        v.optional(v.string()),
        v.transform(input => input ?? ''),
        v.string(),
      ),
      AWS_ELASTICACHE_NAME: v.pipe(
        v.optional(v.string()),
        v.transform(input => input ?? ''),
        v.string(),
      ),
      AWS_ELASTICACHE_PORT: v.pipe(
        v.optional(v.string()),
        v.transform(input => {
          const normalizedInput = input?.trim();
          return normalizedInput && normalizedInput.length > 0 ? normalizedInput : '6379';
        }),
        v.transform(Number),
        v.integer('AWS_ELASTICACHE_PORT must be an integer'),
        v.minValue(1, 'AWS_ELASTICACHE_PORT must be between 1 and 65535'),
        v.maxValue(65535, 'AWS_ELASTICACHE_PORT must be between 1 and 65535'),
      ),
      AWS_ELASTICACHE_USERNAME: v.pipe(
        v.optional(v.string()),
        v.transform(input => input ?? ''),
        v.string(),
      ),
      AWS_VERCEL_ROLE_ARN: v.pipe(
        v.optional(v.string()),
        v.transform(input => input ?? ''),
        v.string(),
      ),
      ENABLE_LOCAL_REDIS: v.pipe(
        v.fallback(v.string(), 'false'),
        v.transform(value => value === 'true'),
      ),
      DYNAMODB_SESSIONS_TABLE_NAME: v.pipe(
        v.optional(v.string()),
        v.transform(input => input ?? ''),
        v.string(),
      ),
      AWS_REGION: v.fallback(v.string(), 'us-east-1'),
      AWS_ELASTICACHE_VERCEL_AUTH_ENABLED: v.pipe(
        v.optional(v.string()),
        v.transform(value => value === '1'),
        v.boolean(),
      ),
      DATADOG_API_KEY: v.fallback(v.string(), ''),
      EDGE_CONFIG: v.fallback(v.string(), ''),
      SERVER_SEGMENT_WRITE_KEY: v.fallback(v.string(), ''),
      CCML_ENDPOINT: v.fallback(v.string(), ''),
      TRANSUNION_ENDPOINT: v.fallback(v.string(), ''),
      VERCEL_API_TOKEN: v.fallback(v.string(), ''),
    },
  },
  values: {
    NEXT_PUBLIC_ABSMARTLY_API_KEY: process.env.NEXT_PUBLIC_ABSMARTLY_API_KEY,
    NEXT_PUBLIC_DEPLOYABLE_ENV: process.env.NEXT_PUBLIC_DEPLOYABLE_ENV,
    NEXT_PUBLIC_CLIENT_SEGMENT_WRITE_KEY: process.env.NEXT_PUBLIC_CLIENT_SEGMENT_WRITE_KEY,
    SERVER_SEGMENT_WRITE_KEY: process.env.SERVER_SEGMENT_WRITE_KEY,
    NEXT_PUBLIC_DD_CLIENT_TOKEN: process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN,
    NEXT_PUBLIC_SUPERGRAPH_URL: process.env.NEXT_PUBLIC_SUPERGRAPH_URL,
    NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
    NEXT_PUBLIC_NW_URL: process.env.NEXT_PUBLIC_NW_URL,
    NEXT_PUBLIC_SURVICATE_WORKSPACE_KEY: process.env.NEXT_PUBLIC_SURVICATE_WORKSPACE_KEY,
    NEXT_RUNTIME: process.env.NEXT_RUNTIME,
    LOG_LEVEL: process.env.LOG_LEVEL,
    AWS_ELASTICACHE_HOSTNAME: process.env.AWS_ELASTICACHE_HOSTNAME,
    AWS_ELASTICACHE_NAME: process.env.AWS_ELASTICACHE_NAME,
    AWS_ELASTICACHE_PORT: process.env.AWS_ELASTICACHE_PORT,
    AWS_ELASTICACHE_USERNAME: process.env.AWS_ELASTICACHE_USERNAME,
    AWS_VERCEL_ROLE_ARN: process.env.AWS_VERCEL_ROLE_ARN,
    ENABLE_LOCAL_REDIS: process.env.ENABLE_LOCAL_REDIS,
    DYNAMODB_SESSIONS_TABLE_NAME: process.env.DYNAMODB_SESSIONS_TABLE_NAME,
    AWS_REGION: process.env.AWS_REGION,
    AWS_ELASTICACHE_VERCEL_AUTH_ENABLED: process.env.AWS_ELASTICACHE_VERCEL_AUTH_ENABLED,
    SUPERGRAPH_INTERNAL_URL: process.env.SUPERGRAPH_INTERNAL_URL,
    CRON_SECRET: process.env.CRON_SECRET,
    CARDFINDER_SESSION_TOKEN_SECRET: process.env.CARDFINDER_SESSION_TOKEN_SECRET,
    MARKETPLACE_WEBHOOK_TOKEN: process.env.MARKETPLACE_WEBHOOK_TOKEN,
    CCML_ENDPOINT: process.env.CCML_ENDPOINT,
    TRANSUNION_ENDPOINT: process.env.TRANSUNION_ENDPOINT,
    DATADOG_API_KEY: process.env.DATADOG_API_KEY,
    EDGE_CONFIG: process.env.EDGE_CONFIG,
    VERCEL_API_TOKEN: process.env.VERCEL_API_TOKEN,
  },
});
